function firstDefined(...values) {
   return values.find((value) => value !== undefined && value !== null);
}

function normalizeUser(user = {}) {
   const id = firstDefined(user.noUser, user.idUser, user._id, user.id);
   const normalized = {
      _id: id == null ? null : id,
      name: user.name || user.fullName || user.displayName || 'Unknown'
   };

   if (user.avatar || user.profileUri) {
      normalized.avatar = user.avatar || user.profileUri;
   }

   return normalized;
}

function normalizeMedia(media) {
   if (!media) return undefined;

   const normalized = {
      ...media,
      mimeType: firstDefined(media.mimeType, media.mime_type),
      localUri: firstDefined(media.localUri, media.local_uri, null),
      remoteUri: firstDefined(media.remoteUri, media.remote_uri)
   };

   delete normalized.mime_type;
   delete normalized.local_uri;
   delete normalized.remote_uri;

   return normalized;
}

function normalizeChannelMessage(frameOrMessage = {}) {
   const frame = frameOrMessage.content ? frameOrMessage : null;
   const content = frame ? frame.content || {} : frameOrMessage;
   const id = firstDefined(content._id, frame && frame.id, content.id);
   const createdAt = firstDefined(content.createdAt, content.created_at, frame && frame.ctd);

   const message = {
      ...content,
      _id: id == null ? null : String(id),
      createdAt,
      user: normalizeUser(content.user),
      media: normalizeMedia(content.media),
      frameId: frame ? frame.id : firstDefined(content.frameId, content._id, content.id),
      noFrame: frame ? frame.no : content.noFrame,
      deleted: frame ? frame.deleted === true : content.deleted === true,
      readOnly: frame ? Boolean(frame.meta && frame.meta.isReadonly) : content.readOnly === true
   };

   delete message.created_at;
   return message;
}

function toChannelMessageContent(message = {}) {
   const { pending, failed, deleted, readOnly, frameId, noFrame, ...content } = message;

   return content;
}

function createChannelMessage({ id, text = '', user, createdAt = new Date(), image, audio, video, media } = {}) {
   if (!id) throw new Error('createChannelMessage requires id');

   const message = {
      _id: String(id),
      text,
      createdAt,
      user: normalizeUser(user)
   };

   if (image) message.image = image;
   if (audio) message.audio = audio;
   if (video) message.video = video;
   if (media) message.media = normalizeMedia(media);

   return message;
}

module.exports = {
   createChannelMessage,
   normalizeChannelMessage,
   normalizeMedia,
   normalizeUser,
   toChannelMessageContent
};
